module.exports = "<template> <input type=time class=form-control value.one-way=toInputTimeValue(value) change.delegate=onChange($event) /> </template> ";